import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=9a508248&scoped=true"
import script from "./ImageUploader.ts?vue&type=script&lang=ts&external"
export * from "./ImageUploader.ts?vue&type=script&lang=ts&external"
import style0 from "./ImageUploader.scss?vue&type=style&index=0&id=9a508248&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a508248",
  null
  
)

export default component.exports